<template>
  <v-card class="property-add">
    <v-card-title class="blue-grey--text text--darken-1">
      <h2 class="headline font-weight-bold" style="margin: 0 auto;">
        Cadastrar Propriedade
      </h2>
    </v-card-title>
    <v-card-text>
      <v-form ref="formProperty">
        <v-text-field
          label="Nome da propriedade (*)"
          v-model="nome_propriedade"
          :error="validation.property_name.error"
          :error-messages="validation.property_name.message"
          color="light-blue darken-3"
        ></v-text-field>
        <v-text-field
          label="Nome  do produtor / Proprietário (*)"
          v-model="nome_produtor"
          :error="validation.explorer_name.error"
          :error-messages="validation.explorer_name.message"
          color="light-blue darken-3"
        ></v-text-field>
        <v-row>
          <v-col
            sm11
            xs10
            class="pt-0 pb-0 flex-grow-1 flex-shrink-0"
            style="min-width: calc(100% - 48px);"
          >
            <v-text-field
              label="CPF / CNPJ (*)"
              v-model="numero_registro"
              :error="validation.document_number.error"
              :error-messages="validation.document_number.message"
              color="light-blue darken-3"
            ></v-text-field>
          </v-col>
          <v-col
            sm1
            xs2
            class="align-self-center pt-0 pb-0 pl-0 flex-grow-0 flex-shrink-1 text-center"
            style="max-width: 48px;"
          >
            <v-btn icon @click="openGtaDialog('cpf')">
              <v-icon class="text--darken-3 light-blue--text"
                >help</v-icon
              >
            </v-btn>
          </v-col>
        </v-row>
        <v-checkbox
          class="chebox-isento"
          v-model="ce_isento"
          label="Sou isento de Código de Estabalecimento"
        ></v-checkbox>
        <v-row v-if="!ce_isento">
          <v-col sm11 xs10 class="pt-0 pb-0 flex-grow-1 flex-shrink-0" style="min-width: calc(100% - 48px);">
            <v-text-field 
              :disabled="ce_isento" 
              label="Código do Estabelecimento (*)" 
              v-model="codigo_estabelecimento" 
              :error="validation.establishment_code.error" 
              :error-messages="validation.establishment_code.message" 
              color="light-blue darken-3"
            ></v-text-field>
          </v-col>
          <v-col sm1 xs2 class="align-self-center pt-0 pb-0 pl-0 flex-grow-0 flex-shrink-1 text-center" style="max-width: 48px;">
            <v-btn icon @click="openGtaDialog('establishment_code')">
              <v-icon class="text--darken-3 light-blue--text">help</v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <v-checkbox
          class="chebox-isento"
          v-model="ie_isento"
          label="Sou isento de Inscrição Estadual"
        ></v-checkbox>
        <v-text-field
          v-if="!ie_isento"
          :disabled="ie_isento"
          label="Inscrição Estadual (IE) (*)"
          v-model="numero_ie"
          :error="validation.ie.error"
          :error-messages="validation.ie.message"
          class="mb-3"
        ></v-text-field>

        <p style="color: rgba(0,0,0,.55);">
          * Os campos "CPF/CNPJ" e "Código do Estabelecimento", encontram-se no GTA
        </p>

        <v-col class="text-center">
          <v-btn
            dark
            x-large
            color="light-blue darken-3"
            @click="submit"
          >
            Cadastrar
          </v-btn>
        </v-col>
      </v-form>
      <v-btn
        fab
        text
        icon
        color="light-blue darken-3"
        @click="goBack"
      >
        <v-icon>fas fa-arrow-left</v-icon>
    </v-btn>
    </v-card-text>

    <!-- Dialog de exemplo do GTA -->
    <v-dialog v-model="helpButton">
      <v-card>
        <v-card-title class="light-blue darken-3 white--text">
          Exemplo
        </v-card-title>
        <v-img
          max-height="50vh"
          width="auto"
          class="align-center"
          :src="'static/help/' + helpImgType + '.jpg'"
          contain
        />
        <v-card-actions>
          <v-col class="text-center">
            <v-btn
              @click="helpButton = !helpButton"
              medium
              dark
              color="light-blue darken-3"
              >Ok</v-btn
            >
          </v-col>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="warningDialog" persistent max-width="290">
      <v-card>
        <v-card-title class="warning white--text">
          Propriedade já cadastrada
        </v-card-title>
        <v-card-text class="mt-5">
          <strong
            >Já foi cadastrado uma propriedade relacionada com esse
            produtor.</strong
          >
        </v-card-text>
        <v-card-text>
          Deseja solicitar acesso a essa propriedade?
          <span class="d-block my-2 font-weight-bold">OU</span>
          Se deseja reivindicar essa propriedade, por favor envie um e-mail
          para <strong>suporte@ecotrace.info</strong> com os dados da
          propriedade e produtor desejados.
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn
            depressed
            dark
            class="mb-3"
            color="primary"
            @click="warningDialog = !warningDialog"
          >
            Voltar
          </v-btn>

          <v-btn
            depressed
            dark
            class="mb-3"
            color="primary"
            :loading="loadinSave"
            @click="submitAccess"
          >
            Solicitar acesso
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="confirmDialog" persistent max-width="300">
      <v-card>
        <v-card-title class="success white--text">
          Sucesso
        </v-card-title>
        <v-card-text class="mt-6">
          <strong
            class="subtitle-1 font-weight-regular"
            v-html="textConfirmation"
          ></strong>
        </v-card-text>

        <v-card-actions>
          <v-col class="text-center">
            <v-btn
              @click="confirmAction"
              x-large
              dark
              color="success"
            >Ok</v-btn
            >
          </v-col>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-overlay :value="loadinSave" >
      <v-card
        color="primary"
        width="300"
        dark
      >
        <v-card-text>
          Carregando...
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0 mt-1"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-overlay>
    
    <v-snackbar v-model="errSnackbar" color="error">
      Erro ao tentar salvar
      <v-btn text @click="snackbar = false">
        <v-icon>fa-times</v-icon>
      </v-btn>
    </v-snackbar>
    
  </v-card>
</template>

<script>

import appApi from "../../plugins/api"
import lscache from "lscache"

export default {
  props: ['show', 'close'],
  
  data() {
    return {
      loadinSave: false,
      confirmDialog: false,
      textConfirmation: "",
      nome_propriedade: "",
      nome_produtor: "",
      numero_registro: "",
      codigo_estabelecimento: '',
      numero_ie: "",
      ie_isento: false,
      ce_isento: false,
      usuario_acesso: "",
      helpButton: false,
      helpImgType: "",
      warningDialog: false,
      errSnackbar: "",
      validation: {
        property_name: {
          error: false,
          message: ''
        },
        explorer_name: {
          error: false,
          message: ''
        },
        document_number: {
          error: false,
          message: ''
        },
        establishment_code: {
          error: false,
          message: ''
        },
        ie: {
          error: false,
          message: '',
        }
      },
    }
  },
  methods: {
    confirmAction() {
      try {
        lscache.flush();
      } catch (error) {}
      location.reload();
    },
    clearErrors() {
      for (let key in this.errors) {
        this.errors[key] = false;
      }
    },
    submit() {
      this.clearErrors();
      if (this.$refs.formProperty.validate()) {
        this.loadinSave = true;
        appApi
          .getExplorersAll({
            document_number: this.numero_registro,
            establishment_number: this.codigo_estabelecimento,
            ie: this.numero_ie
          })
          .then(result => {
            if(result.data.data[0] && result.data.data[0].property.user.name) {
              this.usuario_acesso = result.data.data[0].property.user.name
            }
            if (result.data.data.length == 0) {
              this.doPropertySave();
            } else {
              this.loadinSave = false;
              this.warningDialog = true;
            }
          })
          .catch(error => {
            this.loadinSave = false;
            console.log("erro: ", error);
          });
      }
    },
    submitAccess() {
      this.clearErrors();
      if (this.$refs.formProperty.validate()) {
        this.warningDialog = false
        this.loadinSave = true

        appApi.postRomaneiosAccessRequest({
          cpfCnpj: this.numero_registro,
          ie: this.numero_ie
        }).then(result => {
          (this.textConfirmation = "Foi enviado um email para o usuário " + "<strong>"+this.usuario_acesso+"</strong>" + " com a solicitação. Favor aguardar a autorização.”"),
          (this.confirmDialog = true),
          (this.loadinSave = false);
        }).catch(result => {
          this.errSnackbar = true;
          this.loadinSave = false;
          this.warningDialog = !this.warningDialog
        });
      }
    },
    doPropertySave() {
      appApi.postExplorer({
        property_name: this.nome_propriedade,
        name: this.nome_produtor,
        document_number: this.numero_registro.replace(/\D/g, ""),
        establishment_code: this.codigo_estabelecimento.replace(/\D/g,''),
        ie: this.numero_ie.replace(/\D/g, ""),
        ie_free : this.ie_isento,
        ce_free : this.ce_isento
      })
      .then(result => {
        this.textConfirmation = "Cadastro realizado com sucesso!",
        this.confirmDialog = true
      })
      .catch(result => {
        this.errSnackbar = true;
        this.loadinSave = false;
        if (result.response && result.response.status == 400) {
          result.response.data.forEach((element) => {
            console.log(this.validation[element.field].error)
            console.log(this.validation[element.field].message)
            this.validation[element.field].error = true;
            this.validation[element.field].message = element.message;
          });
        }
      });
    },
    openGtaDialog(typeString) {
      this.helpImgType = typeString;
      this.helpButton = true;
    },
    goBack() {
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
  .property-add .chebox-isento >>> .v-input__slot {
    margin-bottom: 0px;
  }
</style>